import { useQuery } from '@apollo/react-hooks';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import Nav from '../../components/dashboard/Nav';
import { Column, Row } from '../../components/Flex';
import GraphQLErrorText from '../../components/GraphQLErrorText';
import Loading from '../../components/Loading';
import { BuyerProfile } from '../../components/profile/BuyerProfile';
import { PurchasesToNoFee } from '../../components/profile/PurchasesToNoFee';
import { SalesToLevel } from '../../components/profile/SalesToLevel';
import { SellerProfile } from '../../components/profile/SellerProfile';
import useAuthOrRedirect from '../../hooks/useAuthOrRedirect';
import { PROFILE } from '../../lib/graphql/queries';

import { Media } from '../../theme/media';
import { HeadingOne } from '../../components/Text';
import { analytics } from '../../lib/analytics';

const SmallContainer = styled(Column)`
  & > * {
    margin-bottom: 1.5rem;
  }
`;

const LargeContainer = styled(Row)`
  & > *:first-child {
    margin-right: 1.5rem;
  }
  margin: auto auto 1.5rem auto;
`;

const Container = styled(Row)`
  margin-right: auto;
  margin-left: auto;
  width: 100%;
  max-width: 100%;
  @media (max-width: 800px) {
    flex-direction: column;
  }
  @media (max-width: 440px) {
    width: 90%;
  }
`;

const Title = styled.p`
  font: normal normal 700 25px/38px Poppins;
  letter-spacing: 0px;
  color: #111723;
  opacity: 1;
  width: 100%;
  margin: 0 auto 1.5rem auto;
  text-align: left;
`;

const Profile = () => {
  const { loading, data, error } = useQuery(PROFILE);

  useEffect(() => {
    analytics.page('Rental Profile');
  }, []);

  if (!useAuthOrRedirect()) return null;

  if (loading) return <Loading />;
  if (error) return <GraphQLErrorText error={error} />;

  const SellerContent = () => (
    <>
      {/* <SellerProfile
        sales={data.mySales.length}
        sellerLevel={data.me.sellerLevel}
        nextSellerLevel={data.me.nextSellerLevel}
      /> */}
      <SalesToLevel
        sales={data.mySalesCount}
        sellerLevel={data.me.sellerLevel}
        nextSellerLevel={data.me.nextSellerLevel}
      />
    </>
  );

  const BuyerContent = () => (
    <>
      <BuyerProfile
        purchases={data.myPurchasesCount}
        noFeePurchases={data.me.noFeePurchases}
      />
      <PurchasesToNoFee purchasesUntilNoFee={data.me.purchasesUntilNoFee} />
    </>
  );

  return (
    <Container>
      <Nav />
      <Column>
        <HeadingOne className="mb-5">Profile</HeadingOne>
        <Media lessThan="md">
          <SmallContainer>
            <SellerContent />
          </SmallContainer>
          <SmallContainer>
            <BuyerContent />
          </SmallContainer>
        </Media>
        <Media greaterThanOrEqual="md">
          <LargeContainer>
            <SellerContent />
          </LargeContainer>
          <LargeContainer>
            <BuyerContent />
          </LargeContainer>
        </Media>
      </Column>
    </Container>
  );
};

export default Profile;
